import React from "react";
import { ReactComponent as DateIcon } from "../../../../icons/target_date.svg";
import { useSelector } from "react-redux";
import { RuvnlTitle } from "../../components";
import { TabSwitcher } from "../../Raj_Dashboard";
import Hamburger from "../../../../components/Hamburger";
// interface SessionInfoProps {
//   OptimizerSessionToken?: string;
//   selectDate?: string;
// }

const MainHeader = () => {
  const SelectedStartDate = useSelector(
    (state: any) => state.ProcurementOptimizerDemoDate.startDate
  );
  const SelectedEndDate = useSelector(
    (state: any) => state.ProcurementOptimizerDemoDate.endDate
  );
  const formatDateWithSuffix = (dateString: string): string => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();

    const month = date.toLocaleString("default", { month: "short" });

    // Add suffix to the day (1st, 2nd, 3rd, etc.)
    const getDayWithSuffix = (d: number): string => {
      if (d > 3 && d < 21) return `${d}th`;
      switch (d % 10) {
        case 1:
          return `${d}st`;
        case 2:
          return `${d}nd`;
        case 3:
          return `${d}rd`;
        default:
          return `${d}th`;
      }
    };

    return `${getDayWithSuffix(day)} ${month} ${year}`;
  };
  const TargetStartDate = formatDateWithSuffix(SelectedStartDate);
  const TargetEndDate = formatDateWithSuffix(SelectedEndDate);
  return (
    <div className="dashboard-header flex items-center justify-between px-4">
      <div className="flex items-start">
        <Hamburger />
        <div className="ms-5">
          <TabSwitcher />
        </div>
        <div>
          <h5 className="text-[18px] text-[#6F6D7C] ms-5 font-medium">
            PowerMarketizer
          </h5>
        </div>
      </div>
      <div className="flex-1 flex justify-center ml-[-60px]">
        <RuvnlTitle />
      </div>
      <div className="flex items-center gap-4">
        {/* Session ID Display */}
        {/* <div className="flex items-center gap-2 px-3 py-1 text-sm rounded-xl bg-[#FFFAF6] text-[#34656D] font-medium shadow-[0_7px_29px_0_rgba(100,100,111,0.2)]">
        <div className="bg-[#34656D] rounded-lg p-1">
          <IdCard className="w-5 h-5 text-[#fff]" />
        </div>
        <div className="flex-1 text-start">
          <p className="text-xs text-gray-500 font-medium">Session ID</p>
          <p className="text-sm font-semibold text-[#34656D]">
          {OptimizerSessionToken}
          </p>
        </div>
      </div> */}

        {/* Date Display */}
        <div className="flex items-end gap-2 px-3 py-1 text-sm">
          <div className="flex-1 text-end">
            <div className="flex items-center justify-end gap-1">
              <DateIcon className="w-5 h-5" />
              <p className="text-xs text-[#34656D] font-medium">
                Target Date Range
              </p>
            </div>
            <p className="text-sm font-medium text-[#6F6D7C]">
              {TargetStartDate} - {TargetEndDate}
            </p>
          </div>
        </div>

        {/* Optional Status Badge (can be enabled later) */}
        {/* 
      <div className="flex items-center gap-2 bg-green-50 px-4 py-3 rounded-lg border border-green-200">
        <div className="relative">
          <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
          <div className="absolute inset-0 w-2.5 h-2.5 bg-green-500 rounded-full animate-ping"></div>
        </div>
        <span className="text-xs font-semibold text-green-700">ACTIVE</span>
      </div>
      */}
      </div>
    </div>
  );
};

export default MainHeader;  